import React, { useState } from 'react';
import { Outlet, NavLink, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { logout } from '../../store';
import { authAPI } from '../../services/api';
import './Layout.css';

const markets = [
  { key: 'india',  label: 'India',  flag: '🇮🇳' },
  { key: 'us',     label: 'US',     flag: '🇺🇸' },
  { key: 'crypto', label: 'Crypto', flag: '₿'   },
  { key: 'global', label: 'Global', flag: '🌍'  },
];

export default function AppLayout() {
  const { user } = useSelector(state => state.auth);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [collapsed, setCollapsed] = useState(false);

  const handleLogout = async () => {
    try {
      const refresh = localStorage.getItem('refresh_token');
      await authAPI.logout({ refresh_token: refresh });
    } catch {}
    dispatch(logout());
    navigate('/login');
  };

  return (
    <div className={`layout ${collapsed ? 'collapsed' : ''}`}>
      {/* Sidebar */}
      <aside className="sidebar">
        <div className="sidebar-header">
          <div className="sidebar-logo">
            <span className="sidebar-logo-icon">📈</span>
            {!collapsed && <span className="sidebar-logo-text">StockIQ</span>}
          </div>
          <button className="sidebar-toggle" onClick={() => setCollapsed(!collapsed)}>
            {collapsed ? '→' : '←'}
          </button>
        </div>

        <nav className="sidebar-nav">
          <div className="sidebar-section">
            {!collapsed && <span className="sidebar-section-label">MAIN</span>}
            <NavLink to="/dashboard" className={({isActive}) => `sidebar-link ${isActive ? 'active' : ''}`}>
              <span className="sidebar-icon">⚡</span>
              {!collapsed && <span>Dashboard</span>}
            </NavLink>
            <NavLink to="/portfolio" className={({isActive}) => `sidebar-link ${isActive ? 'active' : ''}`}>
              <span className="sidebar-icon">💼</span>
              {!collapsed && <span>Portfolio</span>}
            </NavLink>
            <NavLink to="/predictions" className={({isActive}) => `sidebar-link ${isActive ? 'active' : ''}`}>
              <span className="sidebar-icon">🤖</span>
              {!collapsed && <span>AI Predictions</span>}
            </NavLink>
          </div>

          <div className="sidebar-section">
            {!collapsed && <span className="sidebar-section-label">MARKETS</span>}
            {markets.map(m => (
              <NavLink key={m.key} to={`/markets/${m.key}`} className={({isActive}) => `sidebar-link ${isActive ? 'active' : ''}`}>
                <span className="sidebar-icon">{m.flag}</span>
                {!collapsed && <span>{m.label}</span>}
              </NavLink>
            ))}
          </div>

          <div className="sidebar-section">
            {!collapsed && <span className="sidebar-section-label">TOOLS</span>}
            <NavLink to="/alerts" className={({isActive}) => `sidebar-link ${isActive ? 'active' : ''}`}>
              <span className="sidebar-icon">🔔</span>
              {!collapsed && <span>Alerts</span>}
            </NavLink>
            <NavLink to="/reports" className={({isActive}) => `sidebar-link ${isActive ? 'active' : ''}`}>
              <span className="sidebar-icon">📊</span>
              {!collapsed && <span>Reports</span>}
            </NavLink>
            <NavLink to="/accuracy" className={({isActive}) => `sidebar-link ${isActive ? 'active' : ''}`}>
              <span className="sidebar-icon">🎯</span>
              {!collapsed && <span>Accuracy</span>}
            </NavLink>
            
            {user?.role === 'admin' && (
              <NavLink to="/admin" className={({isActive}) => `sidebar-link ${isActive ? 'active' : ''}`}>
                <span className="sidebar-icon">👑</span>
                {!collapsed && <span>Admin</span>}
              </NavLink>
            )}
          </div>
        </nav>

        <div className="sidebar-footer">
          <div className="sidebar-user">
            <div className="sidebar-avatar">
              {user?.full_name?.[0] || user?.username?.[0] || 'U'}
            </div>
            {!collapsed && (
              <div className="sidebar-user-info">
                <span className="sidebar-user-name">{user?.full_name || user?.username}</span>
                <span className="sidebar-user-role">{user?.role}</span>
              </div>
            )}
          </div>
          <button className="sidebar-logout" onClick={handleLogout} title="Logout">
            🚪
          </button>
        </div>
      </aside>

      {/* Main content */}
      <main className="main-content">
        <Outlet />
      </main>
    </div>
  );
}
